import React, {Component} from 'react'
import PageLayout from '../pagelayout';
import about1icon from "../../assets/layout/abouticon1.png"
import about2icon from "../../assets/layout/abouticon2.png"
import about3icon from "../../assets/layout/abouticon3.png"
import MobileDetails from './mobiledetails';
import Banner from './banner';
import Footer from './footer';
import LazyImg from '../lazyimg'; 
import twentyfour from "../../assets/Icons/24.png";
import sos from "../../assets/Icons/SOS.png";
import toprated from "../../assets/Icons/toprated.png";

class AboutUs extends Component{
    render(){
        return (
            <PageLayout bgWhite fullWidth pad={false} headerbg={'#feec6b'}>
                <Banner />
                <AboutUsCon 
                    heading="About Ouja" 
                    bg='about-us-bg' 
                    subtitle="Redefining Trips, Pick-up & Drop for You"
                >
                
                    <div className="static-content">
                        <p className="text-center m-b-10">Founded in 2018, Ouja is one of the emerging  pick-up & drop service company in Chennai. We are a learning organization and have a team who believes in themselves and their company, a team with a winning attitude. We value self-development and our vision is to establish continuing excellence in the delivery capabilities focused on the customer.<br />Ouja is revolutionizing urgent deliveries as we want to help you propel your business to success. From retail to health care, food to business-related items, you can trust Ouja to deliver your packages on time and with a special care. Our delivery executives are always uniformed and look professional.<br /> Ouja integrates value-added services, city transportation and distribution of consignments for customers onto a mobile technology platform ensuring a quick, convenient, and transparent service fulfillment. Ouja is focused on leveraging the best of technology, commuting experience and building innovative solutions to build a high quality interactive and productive experience for its users.</p>
                    </div>
                    <div className="container">
                        <div className="row m-t-30">
                            <div className="col-md-4">
                                <div className="flex-center flex-column">
                                    <LazyImg className="h100" src={about1icon} alt=""/>
                                    <h4 className="f-600">Download Mobile App</h4>
                                    <p className="text-center">Download ouja app from play store. Sign up to render the best service.</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="flex-center flex-column">
                                    <LazyImg className="h100" src={about2icon} alt=""/>
                                    <h4 className="f-600">Pick & Deliver</h4>
                                    <p className="text-center">Our executive will pick you or your products from the place of existence and drop you or deliver it at your destination.</p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="flex-center flex-column">
                                    <LazyImg className="h100" src={about3icon} alt=""/>
                                    <h4 className="f-600">Collect & Deliver</h4>
                                    <p className="text-center">Our driver will buy the products from the place of your choice and deliver it to your destination.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </AboutUsCon>
                <AboutUsCon 
                    heading="Why Ouja?" 
                    subtitle="Redefining Pick-up & Drop for You"
                >
                    <div className="static-content">
                        <p className="text-center m-b-10"></p>
                    </div>
                    <MobileDetails />
                </AboutUsCon>
                <AboutUsCon
                    heading="Our Values" 
                    bg={"footertop"}
                >
                    <div className="container">
                        <div className="row">
                            <div className="col-md-4">
                                <div className="row">
                                    <div className="col-md-3">
                                        <LazyImg src={twentyfour} alt="" />
                                    </div>
                                    <div className="col-md-9">
                                        <h4>24/7 Customer Support</h4>
                                        <p>A dedicated 24x7 customer support team always at your service to help solve any problem</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="row">
                                    <div className="col-md-3">
                                        <LazyImg src={sos} alt="" />
                                    </div>
                                    <div className="col-md-9">
                                        <h4>Your Safety First</h4>
                                        <p>Keep your loved ones informed
    about your travel routes or call
    emergency services when in need</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="row">
                                    <div className="col-md-3">
                                        <LazyImg src={toprated} alt="" />
                                    </div>
                                    <div className="col-md-9">
                                        <h4>Top Rated Driver-Partners</h4>
                                        <p>All our driver-partners are
    background verified and trained to
    deliver only the best experience</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </AboutUsCon>
                <Footer />
            </PageLayout>
        )
    }
}

export const AboutUsCon = ({children, bg = '', heading, subtitle}) => (
    <div className={`about-us ${bg}`.trim()}>
        <div className="container p-b-10">
            <div className="flex-center">
                {heading && <h1 className="m-t-20 f-54">{heading}</h1>}
            </div>
            <h3 className="text-center f-600 m-t-30">{subtitle}</h3>
            {children}
        </div>
    </div>
)

export default AboutUs
